<template>
  <UiCard>
    <div slot="title"> <ReportTitle /> </div>

    <div slot="content">
      <!-- Option for handle bar click -->
      <!-- :bar-options="options" -->
      <BarChart :chart-data="datacollection" css-classes="finances-chart-container" />
    </div>
  </UiCard>
</template>

<script>
import BarChart from '@/components/chart/charts/Bar.js'
import UiCard from '@/components/card/UiCard.vue'
import getBarData from '@/components/chart/util/getBarData'
import ReportTitle from './ReportTitle.vue'

import cloneDeep from 'lodash/cloneDeep'

import syncQuery from '@/mixins/syncUrlQuery'

import { CURRENT_YEAR, CURRENT_MONTH, CURRENT_DAY } from '@/config/date'
import { mapGetters } from 'vuex'

export default {
  components: { UiCard, BarChart, ReportTitle },
  mixins: [syncQuery],
  data() {
    return {
      datacollection: {},
    }
  },
  computed: {
    ...mapGetters({
      report: 'finances/currentReport',
    }),
    options() {
      const vm = this

      return {
        onClick: function () {
          const data = getBarData.apply(this, arguments)

          vm.onClickBar(data)
        },
      }
    },
  },
  watch: {
    report: {
      handler: function () {
        if (!this.report) return
        this.datacollection = cloneDeep(this.report)
      },
      deep: false,
      immediate: false,
    },
  },
  methods: {
    onClickBar({ dataset, xLabelValue }) {
      const month = +this.$query.month || CURRENT_MONTH
      const year = +this.$query.year || CURRENT_YEAR
      const day = xLabelValue || CURRENT_DAY

      const datasetLabel = dataset.label
      const date = `${year}-${month}-${day}`

      const routeData = this.$router.resolve({
        name: 'finances-detail',
        query: { dataset: datasetLabel, date },
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style lang="scss">
.finances-chart-container {
  height: 200px;

  @include media_tablet() {
    height: 300px;
  }

  @include media_desktop() {
    height: 400px;
  }
}
</style>
